// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/await-thenable, @typescript-eslint/no-floating-promises, @typescript-eslint/no-misused-promises, react-hooks/exhaustive-deps, react-hooks/immutability */

import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Segment, Button, Modal, Checkbox, Loader } from "semantic-ui-react";
import { toast } from "react-toastify";

import { useDispatch, useSelector } from "react-redux";
import { useAuth0 } from "../../../../auth/auth0";
import _ from "lodash";

import TreatmentsTable from "./TreatmentsTable";

import { useModuleNavigation } from "../../../../hooks/useModuleNavigation";

import * as protocolActions from "../../../../redux/actions/protocolActions";
// import * as applicationActions from "../../../../redux/actions/applicationActions";

const Summary = () => {
	const dispatch = useDispatch();
	const { getTokenSilently } = useAuth0();
	const moduleNavigation = useModuleNavigation();
	const history = useHistory();

	//-- Data Sources
	const clientId = useSelector((state) => (state.clients ? state.clients.currentId : null));
	const [summaryInfo, setSummaryInfo] = useState([]);
	const [summaryTableData, setSummaryTableData] = useState([]);
	const [groundData, setGroundData] = useState([]);
	const [trialGroundData, setTrialGroundData] = useState([]);
	// const [applications, setApplications] = useState([]);

	//-- UI Control
	const [loading, setLoading] = useState(true);
	const [saving, setSaving] = useState(false);
	const [finishProtocolModalOpen, setFinishProtocolModalOpen] = useState(false);
	const [keepTreatmentNames, setKeepTreatmentNames] = useState(false);
	// const [propApps, setPropApps] = useState(true);

	useEffect(() => {
		if (clientId) {
			getSummaryInfo(clientId);
		}
	}, [clientId]);

	async function getSummaryInfo(clientId) {
		setLoading(true);
		try {
			const accessToken = await getTokenSilently();
			const summaryRes = await dispatch(
				protocolActions.getSummaryInfo(moduleNavigation.protocolId, clientId, accessToken),
			);
			setSummaryInfo(summaryRes);
			stageSummaryInfo(summaryRes);
			stageGroundData(summaryRes);

			// const res = await dispatch(
			// 	applicationActions.getProtocolApplications(moduleNavigation.protocolId, clientId, accessToken)
			// );
			// setApplications(res.data);
			setLoading(false);
		} catch {
			setLoading(false);
		}
	}

	function stageSummaryInfo(summaryData) {
		let tableData = _.map(summaryData.treatments, (t) => {
			if (!t.applications) {
				t.applications = [];
			}
			if (!t.associatedTrials) {
				t.associatedTrials = [];
			}
			t.applications = t.applications.concat(
				_.filter(summaryData.applications, (a) => {
					return a.trialTreatmentId === t.trialTreatmentId;
				}),
			);
			t.associatedTrials = t.associatedTrials.concat(
				_.filter(summaryData.associatedTrials, (at) => {
					return at.trialTreatmentId === t.trialTreatmentId;
				}),
			);
			return t;
		});
		setSummaryTableData(tableData);
	}

	function stageGroundData(summaryData) {
		let groupedGroundData = _.groupBy(summaryData.protocolGroundData, "datasetNumericalId");

		setGroundData(groupedGroundData);
		setTrialGroundData(summaryData.trialGroundData);
	}

	function handleFinishProtocolModalOpen() {
		setFinishProtocolModalOpen(!finishProtocolModalOpen);
	}

	async function finishProtocol() {
		setSaving(true);
		try {
			const accessToken = await getTokenSilently();
			await dispatch(
				protocolActions.setSummaryInfo(moduleNavigation.protocolId, !keepTreatmentNames, clientId, accessToken),
			);

			// if (propApps) {
			// 	await dispatch(
			// 		applicationActions.propagateProtocolApplicationsToTrials(
			// 			applications,
			// 			moduleNavigation.protocolId,
			// 			clientId,
			// 			accessToken
			// 		)
			// 	);
			// }

			toast.success("Protocol info saved successfully.");
			handleFinishProtocolModalOpen();
			setSaving(false);
			history.push(moduleNavigation.createProtocolLink(true, moduleNavigation.protocolId, "overview-status"));
		} catch (err) {
			toast.error("Failed to save protocol info. Please try again.");
			console.log(err);
			setSaving(false);
		}
	}

	return loading ? (
		<Loader active />
	) : summaryInfo.applications?.length === 0 ||
	  summaryInfo.associatedTrials?.length === 0 ||
	  summaryInfo.treatments?.length === 0 ? (
		<Segment>
			<p>{"Protocol has not been fully set up yet. Summary cannot be displayed yet."}</p>
		</Segment>
	) : (
		<>
			<Segment basic style={{ minHeight: 50, marginBottom: 30 }}>
				<Button
					id="form-button-back"
					floated="left"
					compact
					secondary
					content={"Back"}
					disabled={saving}
					onClick={() => {
						history.push(moduleNavigation.createProtocolLink(true, moduleNavigation.protocolId, "associate-trials"));
					}}
				/>
				<Modal
					open={finishProtocolModalOpen}
					trigger={
						<Button
							id="button-finish-protocol"
							compact
							primary
							disabled={saving}
							floated="right"
							content={"Finish Protocol"}
							onClick={handleFinishProtocolModalOpen}
						/>
					}
				>
					<Modal.Header>Protocol Completion</Modal.Header>
					<Modal.Content scrolling>
						Confirmation will transfer treatment names/types and create applications and assessments for linked trials.{" "}
						<br />
						<br />
						<Checkbox
							checked={keepTreatmentNames}
							onChange={(event, { checked }) => {
								setKeepTreatmentNames(checked);
							}}
						/>
						{"  "}
						Keep existing names (Do not overwrite treatment names on trials using treatment names).
						{/* <br />
						<br />
						<Checkbox
							checked={propApps}
							onChange={(_e, { checked }) => {
								setPropApps(checked);
							}}
						/>
						{"  "}
						Propagate changes to trial applications. */}
					</Modal.Content>
					<Modal.Actions>
						<Button primary floated="right" loading={saving} onClick={finishProtocol}>
							Confirm
						</Button>
						<Button color="red" floated="right" loading={saving} onClick={handleFinishProtocolModalOpen}>
							Cancel
						</Button>
						<br style={{ clear: "both" }} />
					</Modal.Actions>
				</Modal>
			</Segment>
			<Segment basic>
				<TreatmentsTable
					summaryInfo={summaryTableData}
					applications={summaryInfo.applications}
					associatedTrials={summaryInfo.associatedTrials}
					groundData={groundData}
					trialGroundData={trialGroundData}
				/>
				{/* <TrialApplicationsTable applications={applications} associatedTrials={summaryInfo.associatedTrials} /> */}
			</Segment>
		</>
	);
};

export default Summary;
